module.exports = __webpack_public_path__ + "img/home_global.d790244c.png";